import React from "react";
import { Upload, Button, Typography, Divider } from "antd";
import { PlusOutlined, PictureOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ImagesStep = ({ formData, updateFormData, loading }) => {
  const fileList = formData?.imageryFiles || [];

  const onFilesChange = ({ fileList }) => {
    const locals = (fileList || []).filter((f) => !f.isServer);
    updateFormData({ imageryFiles: locals });
  };

  const total = (fileList || []).length;

  return (
    <div>
      <Title level={3} style={{ marginBottom: "16px" }}>
        <PictureOutlined style={{ marginRight: 8 }} />
        Breakdown Media (Optional)
      </Title>

      <Text type="secondary" style={{ display: "block", marginBottom: "16px" }}>
        Add photos, videos or pdfs related to the breakdown. You can skip this
        step.
      </Text>

      <Divider style={{ margin: "16px 0" }} />

      <div>
        <Text strong>Media </Text>
        <Upload
          listType="picture-card"
          multiple
          beforeUpload={() => false}
          fileList={fileList}
          onChange={onFilesChange}
          style={{ margin: "8px 0 0 0", width: "48px", height: "48px" }}
          disabled={loading}
        >
          <Button style={{ border: 0, background: "none" }} type="button">
            <PlusOutlined style={{ fontSize: "24px" }} />
          </Button>
        </Upload>
        {total > 0 ? (
          <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
            Uploaded images: {total}
          </Text>
        ) : null}
      </div>
    </div>
  );
};

export default ImagesStep;
